<script>
import TableDfe from './TableDfe.vue'
import Sidebar from './Sidebar.vue'
import Topbar from './Topbar.vue'
import services from '@/http'
import fileSaver from 'file-saver'
import masks from '@/methods/masks'
import VueSelect from 'vue-select'
import toast from '@/methods/toast'
import messages from '@/methods/messages'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'Dfes',
  props: {
    document: String,
    descriptionDocument: String
  },
  components: {
    TableDfe,
    Sidebar,
    Topbar,
    VueSelect
  },
  created () {
    this.loading = false
    this.sizeForPages = localStorage.sizeForPages ? localStorage.sizeForPages : 10
    this.loadDafaultsDates()
  },
  methods: {
    loadDafaultsDates () {
      let currentDate = new Date()
      let currentMonth = (currentDate.getMonth() + 1)

      currentMonth = (currentMonth.toString().length === 1) ? '0' + currentMonth : currentMonth

      let lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth()+1, 0)
      this.filter.startDate = currentDate.getFullYear() + '-' + currentMonth + '-01'
      this.filter.finalDate = currentDate.getFullYear() + '-' + currentMonth + '-' + lastDate.getDate()
    },
    validFilter () {
      if ((this.filter.startDate === '') || (this.filter.finalDate === '')) {
        toast.toastError('Filtro de datas invalidos!')
        return false
      } else if (this.currentEmitente.value === '') {
        toast.toastError('Selecione um emitente!')
        return false
      }  else if (this.filter.finalNumber !== null && this.filter.finalNumber !== '' && this.filter.finalNumber !== 0 ) {
        if (this.filter.startNumber === null || this.filter.startNumber === '' || this.filter.startNumber === 0 ) {
          toast.toastError('Selecione a numeração inicial!')
          return false
        }
      } else if (this.filter.startNumber !== null && this.filter.startNumber !== '' && this.filter.startNumber !== 0 ) {
        if (this.filter.finalNumber === null || this.filter.finalNumber === '' || this.filter.finalNumber === 0 ) {
          toast.toastError('Selecione a numeração final!')
          return false
        }
      }

      return true
    },
    clearStatus () {
      this.filter.status = null
    },
    alteredPagination () {
      this.sizeForPages = this.sizeForPages > 30 ? 30 : this.sizeForPages
      this.sizeForPages = this.sizeForPages < 0 ? 10 : this.sizeForPages
      localStorage.sizeForPages = this.sizeForPages

      if (this.myData.length > 0) {
        this.filterData(0)
      }
    },
    loadFilterInMemory () {
        this.filter.selecteds.startDate = this.filter.startDate
        this.filter.selecteds.finalDate = this.filter.finalDate
        this.filter.selecteds.status = this.filter.status
    },
    filterData (param) {
      if (this.validFilter()) {
        this.filter.emitente = this.currentEmitente.value
        this.filter.qttForPage = this.sizeForPages
        this.filter.newPage = param !== 0 ? this.filter.newPage + param : param

        let action = { form: { name: this.document, filter: this.filter } }

        this.loadFilterInMemory()

        this.loading = true
        services.auth.getDfes(action)
          .then(res => {
            this.loading = false
            this.myData = res.body.docs.docs
            this.qttRec = res.body.docs.qttRec

            this.currentPage = res.body.docs.currentPage
            this.myData.map(item => {
              item.checked = false
              item.total = masks.maskReal(item.total)            
              item.cnpj_dest = masks.maskCpfCnpj(item.cnpj_dest)
            })
            if (this.myData.length === 0) {
              toast.toastError('Nenhum documento encontrado!')
            }
            this.updateTotais()
          })
          .catch((err) => {
            this.loading = false
            let msg = messages.getMessage(err, 'Nenhum documento encontrado!')
            toast.toastError(msg)
          })
        window.scrollTo(0, 10)
      }
    },
    loadEmitentes () {
      services.auth.getEmitentes({ contador_id: this.currentContador })
        .then(res => {
          this.listaEmitentes = res.body.emitentes.emitentes
        })
        .catch(res => {
          let msg = messages.getMessage(res, 'Falha ao carregar emitentes!')
          toast.toastError(msg)
        })
    },
    updateTotais () {
      let action = { form: { name: this.document, filter: this.filter } }
      services.auth.totaisDfe(action).then((res) => {
        let totalDfe = res.data.data.totalDfes

        this.totais.autorizada = masks.maskReal(totalDfe.autorizada)
        this.totais.autorizadaForaPrazo = masks.maskReal(totalDfe.autorizadaForaPrazo)
        this.totais.cancelada = masks.maskReal(totalDfe.cancelada)
        this.totais.inutilizada = masks.maskReal(totalDfe.inutilizada)
        this.totais.denegada = masks.maskReal(totalDfe.denegada)
      })
    },
    downloadDocumentos (param) {
      this.filter.selecteds.active = param
      this.filter.emitente = this.currentEmitente.value
      let startNumber = this.filter.startNumber
      let finalNumber = this.filter.finalNumber
      let startDate = this.filter.startDate
      let finalDate = this.filter.finalDate

      if (this.filter.selecteds.active === true) {
        startDate = this.filter.selecteds.startDate
        finalDate = this.filter.selecteds.finalDate
        startNumber = this.filter.selecteds.startNumber
        finalNumber = this.filter.selecteds.finalNumber
      }

      this.myData.map(item => {
        if (item.checked === true) {
          this.filter.selecteds.itens.push(item.id)
        }
      })

      let action = { 
        filter: { 
          selecteds: this.filter.selecteds,
          name: this.document,
          startNumber: startNumber,
          finalNumber: finalNumber,
          startDate: startDate,
          finalDate: finalDate,
          emitenteId: this.filter.emitente,
          status: this.filter.status
         }
       }
      this.loading = true
      services.auth.downloadDfes(action).then(res => {
        this.loading = false
        let blob = new Blob([res.data], { type: 'application/zip;charset=utf-8' })

        let nameDocument
        let indexEmit = this.listaEmitentes.map(e => { return e.value }).indexOf(this.filter.emitente)
        if (indexEmit !== -1) {
          nameDocument = this.listaEmitentes[indexEmit].label
        } else {
          nameDocument = 'documentos'
        }
        fileSaver.saveAs(blob, nameDocument + '.zip')
      }).catch(res => {
        this.loading = false
        let msg = messages.getMessage(res, 'Falha ao realizar download!')
        toast.toastError(msg)
      })
      this.filter.selecteds.itens = []
    },
    setCurrentContador (id) {
      this.currentContador = id
      localStorage.idContador = id
      this.loadEmitentes()
    }
  },
  data () {
    return {
      myTitles: ['Status', 'Número', 'Série', 'Emissão', 'CNPJ Dest.', 'Destinatario', 'Total'],
      myFields: ['numero', 'serie', 'emissao', 'cnpj_dest', 'destinatario', 'total'],
      myData: [],
      listaEmitentes: [],
      currentContador: 0,
      currentEmitente: { id: 0, value: '' },
      currentPage: 1,
      sizePages: [
        { id: 1, value: 10 },
        { id: 2, value: 15 },
        { id: 3, value: 20 },
        { id: 4, value: 30 }
      ],
      sizeForPages: 10,
      qttRec: 0,
      loading: false,
      filter: {
        newPage: 0,
        emitente: 0,
        startNumber: '' ,
        finalNumber: '',
        startDate: '2021-01-01',
        finalDate: '2021-01-15',
        status: null,
        selecteds: {
          active: false,
          itens: [],
          startNumber: '',
          finalNumber: '',
          startDate: '',
          finalDate: '',
          status: null
        }
      },
      statusOptions: [
        {id: 0, value: 'A', description: 'Autorizada'},
        {id: 4, value: 'F', description: 'Autorizada Fora do Prazo'},
        {id: 1, value: 'C', description: 'Cancelada'},
        {id: 2, value: 'I', description: 'Inutilizada'},
        {id: 3, value: 'D', description: 'Denegada'},
      ],
      totais: {
        autorizada: 'R$ 0,00',
        cancelada: 'R$ 0,00',
        inutilizada: 'R$ 0,00',
        denegada: 'R$ 0,00',
        autorizadaForaPrazo: 'R$ 0,00', 
      }
    }
  }
}
</script>

<template>
  <div class="home">  
    <Topbar
      v-on:updateSelectedContador="setCurrentContador"
    />

    <div v-if="loading" class="loading-default showmodal">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper">
        <div class="container-fluid">
            <div class="title-document">
              <p class="text-blue-dt"><strong>{{descriptionDocument}}</strong></p>
            </div>
            <div class="card-body">
              <button v-on:click="downloadDocumentos(false)" type="button" class="btn btn-secondary btn-sm space-negative-button-left">Baixar Todos XML's</button>
              <button v-on:click="downloadDocumentos(true)" type="button" class="btn btn-secondary btn-sm space-default-button-left">Baixar Selecionados</button>
            </div>

          <div class="card mb-3 border-flat">
            <div class="card-body border-flat">
                <form>
                  <div class="row">
                    <div class="col-md-2.3 m-left">
                      <label for="filter-data-inicio">Data Inicial</label>
                      <input required type="date" class="form-control" v-model="filter.startDate">
                    </div>
                    <div class="col-md-2.3 m-left">
                      <label for="filter-data-fim">Data Final</label>
                      <input required type="date" class="form-control" v-model="filter.finalDate">
                    </div>

                    <div class="sz-default col-md-2.3 m-left">
                      <label for="filter-data-inicio">Numeração Inicial</label>
                      <input required type="number" class="form-control" v-model="filter.startNumber">
                    </div>
                    <div class="sz-default col-md-2.3 m-left">
                      <label for="filter-data-fim">Numeração Final</label>
                      <input required type="number" class="form-control" v-model="filter.finalNumber">
                    </div>

                    <div class="sz-default col-md-2.3 m-left">
                      <label for="filter-data-fim">Status</label>
                      <select
                        class="form-control"
                        v-model="filter.status"
                        v-on:keyup.8="clearStatus()"
                        v-on:keyup.46="clearStatus()"
                      >
                        <option
                          v-for="subitem in statusOptions"
                          :key="subitem.id"
                          :value="subitem.value"
                        >
                          {{subitem.description}}
                        </option>
                      </select>
                    </div>
                  </div>

                    <div class="row">
                    <div class="col">
                      <label for="item.name">Emitentes</label>
                      <div class="input-group">
                        <div class="select2-container select2-container-multi full-width text-right">
                          <vue-select
                            required
                            class=""
                            name="select2"
                            :options="listaEmitentes"
                            v-model="currentEmitente"
                            :searchable="true">
                          </vue-select>
                          <button
                            v-on:click="filterData(0)"
                            type="button"
                            class="btn bg-blue-dt space-default-button-top">
                              Pesquisar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
            </div>
          </div>
          <TableDfe
            v-bind:titles="myTitles"
            v-bind:fields="myFields"
            v-bind:generalData="myData"
            v-bind:totais="totais"
          >
          </TableDfe>
        </div>

        <select
          class="form-control selected-small"
          v-model="sizeForPages"
          @change="alteredPagination()"
        >
          <option v-for="subitem in sizePages"
            :key="subitem.id"
            :value="subitem.value"
          >
            {{ subitem.value }}
          </option>
        </select>
     
        <div class = "ml-auto" v-if = "myData.length !== 0">
          <nav aria-label="Navegação de página exemplo" v-if="currentPage !== 0">
            <ul class="pagination justify-content-right">
              <li class="page-item" v-if="currentPage > 1">
                <a class="page-link pointer-cursor" v-on:click="filterData(-1)">Anterior</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link pointer-cursor" tabindex="-1">{{parseInt(currentPage)}}</a>
              </li>
              <li class="page-item" v-if="myData.length >= sizeForPages">
                <a class="page-link pointer-cursor" v-on:click="filterData(+1)">Próximo</a>
              </li>
            </ul>
          </nav>
        </div>

        <div class="qtt-rec" v-if="myData.length !== 0">
          <a>Mostrando de {{ ((filter.newPage + 1) * sizeForPages) - sizeForPages +1 }} 
                      até {{ (filter.newPage + 1) * sizeForPages }} de {{ qttRec }} registros.</a>
        </div>

      </div>
    </div>

    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<style scoped>  
  .d-acoes{float: left;}
  .full-width{width: 100%;}
  .space-default-button-top{margin-top: 10px;}
  .space-default-button-left{margin-left: 10px;}
  .space-negative-button-left{margin-left: -20px;}

  .title-document{margin: 0; display: flex; margin-top: 5px; font-size: 14px; padding: 0;}
  .title-document p {margin: 0; text-align: left; color: #999; font-size: 1.3em;}

  .loading-default{display: none; height: 100px; width: 100px; background: rgba(204, 192, 192, .5); margin-top: 100px; margin-left: 50%; border-radius: 5px; padding-left: 35px; padding-top: 30px;}
  .showmodal {display: block; position: fixed; z-index: 99999;  overflow: auto;}
  .selected-small{width: 80px; margin-left: 30px; float: left;}
  .justify-content-right{float: right; margin-right: 30px;}
  .m-left{margin-left: 15px; margin-bottom: 10px;}
  .qtt-rec a{margin-left: 20px; padding-top: 10px}
  .qtt-rec{padding-top: 10px; color: #666}
  .sz-default{width: 140px}
  .btn-destak {background: rgb(175, 189, 19); border: none; color: white}
</style>
